import { useAuth } from '@context/AuthProvider';
import { Author } from 'src/types/types';

export const getCurrentUserAsMember = (): Author | undefined => {
  const { currentUser } = useAuth();

  if (!currentUser?.member) {
    return undefined;
  }

  return {
    name: currentUser.member.fullName,
    slug: currentUser.member.slug,
  };
};
